let ssg = false

export function initSSG(value: boolean) {
  ssg = value
}

export function isSSG() {
  return ssg
}
